import React from "react"
import { Button, Modal } from "antd"
import { MdInfoOutline } from "react-icons/md"

// This exact server explanation is emitted only by the provider-refusal branch.
// Missing images, loading failures and other errors must not imply moderation.
export const isStoryboardDeclined = (message) => message === "The image service declined this frame. No automatic retry was made."

export const StoryboardGuidelinesLink = ({ onClick, declined = false }) => <Button
  type="link" className="h-auto whitespace-normal text-left px-0" icon={<MdInfoOutline aria-hidden="true" size={17} />}
  onClick={onClick}>{declined ? "View AI Content Guidelines" : "AI Content Guidelines"}</Button>

export const StoryboardFailureNotice = ({ message, onGuidelines }) => {
  if (!message) return null
  if (!isStoryboardDeclined(message)) return <p role="alert" className="text-red-600 text-[14px] mt-3">{message}</p>
  return <div role="alert" className="text-[14px] leading-relaxed mt-3 space-y-2">
    <h4 className="font-bold">Image generation declined</h4>
    <p>The AI image provider could not generate this frame. This may be due to content restrictions involving sensitive subjects.</p>
    <p>Your screenplay and character details have not been changed.</p>
    <StoryboardGuidelinesLink declined onClick={onGuidelines} />
  </div>
}

const StoryboardContentGuidelines = ({ open, onClose }) => <Modal
  open={open} onCancel={onClose} title="AI Storyboard — Content Guidelines" centered
  width="min(560px, calc(100vw - 32px))" destroyOnClose
  styles={{ body: { maxHeight: "calc(100dvh - 220px)", overflowY: "auto" } }}
  footer={<Button onClick={onClose}>Close</Button>}>
  <div className="text-[14px] leading-relaxed space-y-4">
    <p>Morphosys supports filmmakers telling stories about real-world issues, including difficult and sensitive subjects.</p>
    <p>However, our AI image providers may restrict or decline the generation of certain content, including scenes involving minors, drugs, explicit violence, sexual content or other sensitive material.</p>
    <p>Your screenplay and character descriptions remain unchanged. These restrictions apply only to AI-generated imagery.</p>
    <p>If an image is declined, Morphosys will explain that the AI provider could not generate it.</p>
    <p><strong>Please note:</strong> AI content restrictions are determined by the image provider, not Morphosys.</p>
  </div>
</Modal>

export default StoryboardContentGuidelines